import React from 'react';
import OnVisible from 'react-on-visible';
import { Image } from 'components';
import './styles.scss';

const FeatureBlock = props => {
  const { data } = props;
  const { primary, items } = data;
  const { content, feature_icon: icon, subtitle, title } = primary;

  // content checks
  const contentHtml = content?.html;
  const titleHtml = title?.html;
  const subtitleHtml = subtitle?.html;
  const hasImage = icon?.url || icon?.localFile;
  // apply class
  return (
    <OnVisible className="feature-block" wrappingElement="section">
      <div className="wrapper">
        <div className="feature-block-text-container">
          {/* TEXT */}
          <div className="feature-block-header">
            {hasImage && <Image className="feature-block-icon" image={icon} />}
            {titleHtml && <div className="feature-block-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
          </div>
          <div className="feature-block-text">
            {subtitleHtml && (
              <div className="feature-block-subtitle" dangerouslySetInnerHTML={{ __html: subtitleHtml }} />
            )}
            {contentHtml && <div className="feature-block-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />}
          </div>
        </div>
        {/* IMAGES */}
        {items.length > 0 && (
          <div className="feature-block-images-container">
            {items.map(item => {
              const { image } = item;
              return <Image className="feature-block-image" image={image} />;
            })}
          </div>
        )}
      </div>
    </OnVisible>
  );
};

export default FeatureBlock;
